import { render, staticRenderFns } from "./zjMenu.vue?vue&type=template&id=96ea6326&scoped=true&"
import script from "./zjMenu.vue?vue&type=script&lang=js&"
export * from "./zjMenu.vue?vue&type=script&lang=js&"
import style0 from "./zjMenu.vue?vue&type=style&index=0&id=96ea6326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ea6326",
  null
  
)

export default component.exports